import { Floor } from '../types/building';

/**
 * Gibt die korrekte Bezeichnung für eine Etage zurück
 */
export const getFloorLabel = (floor: Floor): string => {
  if (floor.number < 0) {
    return `${Math.abs(floor.number)}. UG`;
  }
  return floor.number === 0 ? 'EG' : `${floor.number}. OG`;
};

/**
 * Gibt die Bezeichnung für den "Etage hinzufügen"-Button zurück
 */
export const getAddFloorLabel = (floorsCount: number): string => {
  return floorsCount === 0 ? 'Erdgeschoss hinzufügen' : 'Obergeschoss hinzufügen';
};